import PropTypes from 'prop-types';
import React from 'react';

const Ideal = ({ className }) => (
  <svg
    className={className}
    viewBox="0 0 34 30"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <path fill="#0A0B09" d="M4 26.1547h5.4429V17H4z" />
      <g fill="#0A0B09">
        <path d="M9.162 12.1209c0 1.7234-1.3796 3.1214-3.081 3.1214S3 13.8443 3 12.121C3 10.3974 4.3796 9 6.081 9s3.081 1.3974 3.081 3.1209" />
        <path d="M19.1585 1.9924c3.7846 0 6.9389 1.0387 9.1218 3.0038 2.4676 2.2213 3.7188 5.5869 3.7188 10.0031 0 8.7523-4.2002 13.007-12.8406 13.007H1.967V1.9923h17.1916zM19.528 0H0v29.9986h19.528v-.0057c4.2656-.0588 7.6449-1.1322 10.0429-3.1989 2.9164-2.5134 4.3952-6.4817 4.3952-11.7947 0-2.5397-.389-4.8177-1.156-6.7708-.7339-1.8684-1.8183-3.457-3.2232-4.7217C27.1126 1.2794 23.6394.075 19.528.0066V0z" />
      </g>
      <path
        d="M18.904 25.6325H12V4h6.904-.2787c5.7576 0 11.8862 2.3017 11.8862 10.8447 0 9.0315-6.1286 10.7878-11.8862 10.7878h.2786"
        fill="#B9215E"
      />
      <path
        d="M12.0361 10.8824v3.4404h.7763c.2903 0 .4999-.0165.6287-.0496.1686-.0425.3085-.1146.4197-.2161.1112-.1016.202-.2687.2723-.5014.0702-.2326.1053-.5498.1053-.9513 0-.4016-.035-.7098-.1053-.9249-.0703-.2149-.1686-.3826-.295-.503-.1265-.1205-.287-.202-.4813-.2446-.1452-.033-.4297-.0495-.8535-.0495h-.4672zM11 10h1.8955c.4275 0 .7534.0331.9776.0994.3013.09.5594.2497.7743.4794.215.2295.3784.5106.4906.8432.1121.3326.1682.7427.1682 1.2302 0 .4285-.0526.7977-.1577 1.1078-.1285.3788-.3118.6853-.55.9197-.18.1775-.4229.316-.7289.4153-.229.0735-.5349.1101-.918.1101H11V10z"
        fill="#FFFFFE"
      />
      <path
        d="M12.036 10.2846c.4122 0 .7278.0315.9382.0937.2755.0822.5151.2305.7118.4407.1998.2135.3544.4798.4595.7913.1066.3162.1607.7147.1607 1.1843 0 .4106-.0505.7678-.1501 1.0615-.1206.3556-.294.6462-.515.8637-.1636.1615-.3903.29-.6739.382-.2136.0686-.5082.1033-.8751.1033H10.281v-4.9205h1.755zM10 10v5.4898h2.0921c.3956 0 .7188-.0393.9604-.1167.326-.106.5897-.257.7845-.4492.253-.2488.4498-.577.5849-.9753.1097-.3236.1653-.7119.1653-1.154 0-.501-.0592-.9304-.1758-1.2763-.1182-.3506-.2936-.6517-.5215-.8952a1.8605 1.8605 0 0 0-.8366-.5179C12.8137 10.0344 12.481 10 12.036 10H10z"
        fill="#FFFFFE"
      />
      <path
        d="M11.6077 11.2846c.5123 0 .7302.0251.8227.0461.1692.0372.3087.1075.4157.2094.1086.1035.1954.253.258.4442.0651.1995.0982.4955.0982.88 0 .3856-.0334.6916-.0992.9098-.0624.2064-.1404.3536-.232.4373-.0934.0852-.2144.147-.3596.1837-.1174.0301-.3173.0453-.5947.0453h-.6358v-3.1558h.3267zM11 11v3.725h.9168c.3048 0 .5218-.0176.6632-.0539.1898-.0478.3512-.1315.4793-.2484.1317-.1203.234-.3053.3124-.5655.0751-.2485.1116-.5733.1116-.9929 0-.4207-.0368-.7378-.1125-.9695-.0773-.2366-.1891-.4257-.3321-.562-.1448-.1379-.329-.232-.5478-.28-.156-.0355-.4452-.0528-.8832-.0528H11zM16 15.2051V10h3.804v.8824h-2.7678v1.1527h2.5745v.8824h-2.5745v1.4053h2.8661v.8823H16"
        fill="#FFFFFE"
      />
      <path
        d="M19.804 10.2846v.5978h-2.7678v1.4373h2.5745v.5978h-2.5745v1.69h2.8661v.5976H16.281v-4.9205h3.523zM16 10v5.4898h4.1833v-1.167h-2.8661V13.202h2.5745v-1.167h-2.5745v-.8681h2.7677V10H16zM24.246 13.1416l-.7083-1.9284-.694 1.9284h1.4024zm1.9102 2.0635h-1.1287l-.4485-1.1812h-2.0529l-.4253 1.1812H21L22.9969 10h1.1043l2.055 5.2051z"
        fill="#FFFFFE"
      />
      <path
        d="M23.2115 10.2846l1.9425 4.9205h-.8248l-.4484-1.1812h-2.2477l-.4253 1.1812h-.7972l1.8877-4.9205h.9132zM22.106 10L20 15.4898h1.4044l.4253-1.1812h1.8581l.4485 1.1812h1.4327L23.4016 10H22.106z"
        fill="#FFFFFE"
      />
      <path
        d="M22.8961 11.8235l.505 1.3743h-.9996l.4946-1.3743zM22 13.4825h1.8054L22.8935 11 22 13.4824zM27 15.1624V10h1.0362v4.28h2.5816v.8824H27"
        fill="#FFFFFE"
      />
      <path
        d="M27.0362 10.2846v4.2801h2.5816v.5977H26.281v-4.8778h.7552zM26 10v5.447h3.8988V14.28h-2.5816V10H26z"
        fill="#FFFFFE"
      />
    </g>
  </svg>
);

Ideal.propTypes = {
  className: PropTypes.string,
};

Ideal.defaultProps = {
  className: '',
};

export default Ideal;
